import { API_URL } from '../constants/environment';

export function goToCustomerApp(): void {
  window.location.replace(`${API_URL}?fromDocs=true`);
}
